import moment from 'moment';
import { get as getReseauLc } from '@/api/produit/produitReseauLc';
import { get as getReseauTempo } from '@/api/produit/produitReseau';
import * as tourneeConf from '@/configuration/logistique/tournee/tourneeConf';
import { INFINITE_DAY } from '@/configuration/general';
import { addInformationsOfFacesInLignes } from '@/services/logistique/tourneeModele/addInformationPatrimonialTourneeLigne';
import { getAll } from '@/api/gabed/face/index';
import { NO_PAGINATION } from '@/configuration/clientTableConf';
import getAllTourneeLigne from '@/api/logistique/tourneeLigne/index';
import messageInfo from '@/services/general/messageInformation';
import { getAffectationRegroupement } from '@/api/produit/produitFace';
import formatIsoDate from '@/services/general/formatIsoDate';

async function getFacesIds(affectations, societeId, facesIdDejaPresente, idTournee, dateReference) {
  const dateRef = moment(dateReference);
  const facesIds = affectations.filter((affectation) => {
    const dateFin = affectation.dateFin ? moment(affectation.dateFin) : moment(INFINITE_DAY);
    return (dateRef
      .isBetween(moment(affectation.dateDebut), dateFin, 'day', '[]')
      && affectation.produit.produitFace.faceId
      && !facesIdDejaPresente.some((id) => {
        return affectation.produit.produitFace.faceId === id;
      }));
  }).map((affectation) => { return affectation.produit.produitFace.faceId; });
  const tourneeLigneWithFaceId = (
    await getAllTourneeLigne({ query: { faceIds: facesIds, societeId: societeId } })
  ).data.result.items;
  return facesIds.filter((faceId) => {
    return !tourneeLigneWithFaceId.some((ligne) => {
      return ligne.faceId === faceId && ligne.tournee.id !== idTournee;
    });
  });
}

async function getTourneesLignes(
  affectations, maxOrdre, societeId, facesIdDejaPresente, idTournee, dateReference,
) {
  const tourneeLignes = [];
  let ordre = maxOrdre;
  const facesIds = await getFacesIds(affectations, societeId, facesIdDejaPresente,
    idTournee, dateReference);
  if (facesIds.length === 0) return [];
  facesIds.forEach((id) => {
    tourneeLignes.push({ faceId: id, ordre: ordre });
    ordre += 10;
  });
  const params = {
    query: { ids: facesIds, societeId: societeId, nonCommercialisable: null },
    limit: NO_PAGINATION,
  };
  const facesPatrimonialesInfo = (await getAll(params)).data.result.items;
  if (facesPatrimonialesInfo.length === 0) return [];
  const reseauInformation = (await getAffectationRegroupement({
    dateVisu: formatIsoDate(new Date()),
    produitIds: facesPatrimonialesInfo
      .filter((face) => { return face.produitId; })
      .map((face) => { return face.produitId; }),
  })).data.result;
  addInformationsOfFacesInLignes(facesPatrimonialesInfo, tourneeLignes, reseauInformation);
  return tourneeLignes;
}

export default async function getTourneeLigneFromProduitReseau(
  reseau, ordre, societeId, facesIdDejaPresente, i18n, idTournee, dateReference, messages,
) {
  let affectations = [];
  if (reseau.typeProduit === tourneeConf.TYPE_REGROUPEMENT_LC) {
    affectations = (await getReseauLc(reseau.id)).data.result.produitReseau.affectationsReseauFace;
  } else {
    affectations = (
      await getReseauTempo(reseau.id)).data.result.produitReseau.affectationsReseauFace;
  }
  const tourneeLigne = await getTourneesLignes(
    affectations, ordre, societeId, facesIdDejaPresente, idTournee, dateReference,
  );
  if (affectations.length !== tourneeLigne.length) {
    const dateRef = moment(dateReference);
    const facesDejaPrisIds = affectations.filter((affectation) => {
      const dateFin = affectation.dateFin ? moment(affectation.dateFin) : moment(INFINITE_DAY);
      return (dateRef
        .isBetween(moment(affectation.dateDebut), dateFin, 'day', '[]')
        && affectation.produit.produitFace.faceId
        && !tourneeLigne.some((ligne) => {
          return affectation.produit.produitFace.faceId === ligne.faceId;
        }));
    }).map((affectation) => { return affectation.produit.produitFace.faceId; });
    const tourneeLigneFaceDejaPris = (
      await getAllTourneeLigne({ query: { faceIds: facesDejaPrisIds, societeId: societeId } })
    ).data.result.items;
    const produitFacesWithoutFacePatri = affectations.filter((aff) => {
      return !aff.produit.produitFace.faceId;
    });
    if (produitFacesWithoutFacePatri.length) {
      produitFacesWithoutFacePatri.forEach(aff => {
        messages.push({
          codeFace: aff.produit.reference,
          motif: i18n.t('addEditTourneeModele.facesNotAddListeAffichage.faceNonPatrimoine'),
        });
      });
    }
    tourneeLigneFaceDejaPris.forEach(tourneeLigne => {
      const face = affectations.find(el => el.produit.produitFace.faceId === tourneeLigne.faceId);
      messages.push({
        codeFace: face.produit.reference,
        motif: i18n.t('addEditTourneeModele.info.facesAlreadyInList', { listeAffichage: tourneeLigne.tournee.libelle }),
      });
    });
  } else if (affectations.length > 1) {
    messageInfo(i18n.t('addEditTourneeModele.info.facesAddSuccessMulti'));
  } else {
    messageInfo(i18n.t('addEditTourneeModele.info.facesAddSuccess'));
  }
  return tourneeLigne;
}
